import styled from "styled-components";
import { List } from "discover.medical.react-component-library";

export const StyledList = styled(List)`
  margin-bottom: ${({ theme }) => theme.space.md};
`;
